module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monitor"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "left-bg",
    attrs: {
      "src": require("../../../static/img/video/bg-left.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "right-bg",
    attrs: {
      "src": require("../../../static/img/video/bg-right.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "select",
    on: {
      "click": _vm.up
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("百色市监控")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "oprate"
  }, [_vm._v("收起 "), _c('img', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": require("../../../static/img/video/down.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "oprate"
  }, [_vm._v("展开 "), _c('img', {
    attrs: {
      "src": require("../../../static/img/video/down.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "options"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedNames2),
        expression: "checkedNames2"
      }],
      staticClass: "cb",
      attrs: {
        "id": _vm.ids(index),
        "type": "checkbox"
      },
      domProps: {
        "value": item.text,
        "checked": Array.isArray(_vm.checkedNames2) ? _vm._i(_vm.checkedNames2, item.text) > -1 : (_vm.checkedNames2)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedNames2,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.text,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedNames2 = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedNames2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedNames2 = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.ids(index)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_vm._v(_vm._s(item.text))])])
  }), 0)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "change"
  }, [_c('div', {
    staticClass: "head",
    class: {
      cr: _vm.status
    },
    on: {
      "click": function($event) {
        return _vm.keys(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "head cur2",
    class: {
      cr2: _vm.status1
    },
    on: {
      "click": function($event) {
        return _vm.keys(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "head cur3",
    class: {
      cr3: _vm.status2
    },
    on: {
      "click": function($event) {
        return _vm.keys(3)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "head cur4",
    class: {
      cr4: _vm.status3
    },
    on: {
      "click": function($event) {
        return _vm.keys(4)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, _vm._l((_vm.showList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic-item",
      class: _vm.width2(),
      style: (_vm.width()),
      attrs: {
        "id": _vm.ID(index)
      }
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "total"
  }, [_c('span', [_vm._v("百色市监控总数")]), _vm._v(" "), _c('span', [_vm._v("60个")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/video/pic.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c2913626!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/index.vue
// module id = 2082
// module chunks = 2